import { Module, VuexModule, Action, Mutation, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { Articulo } from '@/types/types'
import { ArticuloService } from '@/services/ArticuloService'
@Module({
  namespaced: true,
  name: 'articulos',
  store,
  dynamic: true
})
class ArticuloModule extends VuexModule {
  items: Articulo[] = []
  service = new ArticuloService()
  current = new ArticuloService().getEmpty()
  itemsSearch: Articulo[] = []

  @Action({ commit: 'setItems' })
  async fetchAll (filtro: string) {
    const articulos = await this.service.fetchAllRequest(filtro)
    return articulos.data.data
  }

  @Action({ commit: 'setItemsSearch' })
  async fetchSearchAll (nombre: string) {
    const articulos = await this.service.searchRequest(nombre)
    return articulos.data.data
  }

  @Action({ commit: 'setCurrent' })
  async fetchOne (id: string) {
    const articulo = await this.service.fetchOneRequest(id)
    return articulo.data.data
  }

  @Action({ commit: 'setToggleEstado' })
  async toggleEstado (id: string, estado: number) {
    await this.service.toggleEstadoRequest(id, estado)
    return { id, estado }
  }

  @Mutation
  setToggleEstado (id: string, estado: number) {
    this.items = this.items.map((item) => {
      if (item.id !== id) return item
      return {
        ...item,
        estado: estado === 1 ? 0 : 1
      }
    })
  }

  @Mutation
  setItemsSearch (items: Articulo[]) {
    this.itemsSearch = items
  }

  @Mutation
  setItems (items: Articulo[]) {
    this.items = items
  }

  @Mutation
  setCurrent (current: Articulo) {
    this.current = current
  }
}
export default getModule(ArticuloModule)
